import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/hooks';
// import './errorpage.css';

function ErrorPage() {
  const navigate = useNavigate();
  const { user } = useAppSelector((state) => state.user);

  useEffect(() => {
    if (user === null) {
      navigate('/login');
    } else {
      // navigate('/account');
    }
  }, [user]);

  return (
    <div className="errorPage">
      <div className="errorPageContainer">
        <div className="errorPageTitle">Такой страницы нет</div>
        <Link className="errorPageLink" to={'/account'}>
          На главную
        </Link>
      </div>
    </div>
  );
}

export default ErrorPage;
